import { creating, exist } from '@campaign-portal/namespace/common/id';
import { LinkDomainStatus } from '@campaign-portal/namespace/common/enums';
import { LinkDomain } from '@campaign-portal/namespace/entities/link-domains/specs';
import { SSLSettings } from '@campaign-portal/namespace/entities/portals/specs';
import { FileInfo } from '@campaign-portal/namespace/common/fileInfo';

const EMPTY_FILE: FileInfo = {
	id: '',
	name: '',
	size: 0,
};

export interface LinkDomainEntityConfig<ID = exist | creating> extends Partial<LinkDomain<ID>> {
	id: ID;
}

export class LinkDomainEntity<ID = exist | creating> implements LinkDomain<ID> {
	readonly id: ID;
	readonly host: string;
	readonly status: LinkDomainStatus;
	readonly editable: boolean;
	readonly sslSettings: SSLSettings;
	readonly sslExpirationDate?: string;
	readonly archivedDate?: string;
	readonly shortLinksCount?: number;

	readonly creationDate?: string | null;
	readonly createdBy?: string | null;
	readonly lastUpdated?: string | null;
	readonly modifiedBy?: string | null;
	readonly deleted: boolean;

	constructor(config: LinkDomainEntityConfig<ID>) {
		this.id = config.id;
		this.host = config.host ?? '';
		this.status = config.status ?? LinkDomainStatus.ACTIVE;
		this.editable = config.editable ?? true;
		this.sslSettings = config.sslSettings ?? {
			certFile: EMPTY_FILE,
			privateKeyFile: EMPTY_FILE,
		};
		this.sslExpirationDate = config.sslExpirationDate;
		this.archivedDate = config.archivedDate;
		this.shortLinksCount = config.shortLinksCount;
		this.creationDate = config.creationDate;
		this.createdBy = config.createdBy;
		this.lastUpdated = config.lastUpdated;
		this.modifiedBy = config.modifiedBy;
		this.deleted = config.deleted ?? false;
	}

	isActive(): boolean {
		return this.status === LinkDomainStatus.ACTIVE;
	}
}
